import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'FRETE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'FRETE_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('freteForm', registro)
    ];
}

export function setFiltro(filtro) {
    return {
        type: 'FRETE_SET_FILTRO',
        payload: filtro
    };
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/frete`);
    return {
        type: 'FRETE_LISTADO',
        payload: request
    };
}

export function getListaDescargaBase() {
    const request = axios.get(`${consts.API_URL}/frete?base=true`);
    return {
        type: 'FRETE_BASE_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/frete`, {
                ...registro,
                datahora_agendamento: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_agendamento),
				itens: (registro.itens || []).map(item => ({
					...item,
                    quantidade: FormatUtils.formatarValorBanco(item.quantidade || 0, 2),
                    km_total: FormatUtils.formatarValorBanco(item.km_total, 0),
                    custo_km_rodado: FormatUtils.formatarValorBanco(item.custo_km_rodado || 0, 2)
                })),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/frete`, {
                ...registro,
                datahora_agendamento: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_agendamento),
				itens: (registro.itens || []).map(item => ({
					...item,
                    quantidade: FormatUtils.formatarValorBanco(item.quantidade || 0, 2),
                    km_total: FormatUtils.formatarValorBanco(item.km_total, 0),
                    custo_km_rodado: FormatUtils.formatarValorBanco(item.custo_km_rodado || 0, 2)
                })),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/frete?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'FRETE_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'FRETE_VEICULO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCliente() {
    const request = axios.get(`${consts.API_URL}/cliente/listarSelect`);
    return {
        type: 'FRETE_CLIENTE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaEndereco() {
    const request = axios.get(`${consts.API_URL}/endereco/listarSelect`);
    return {
        type: 'FRETE_ENDERECO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaFreteDeslocamento() {
    const request = axios.get(`${consts.API_URL}/freteDeslocamento/listarSelect`);
    return {
        type: 'FRETE_DESLOCAMENTO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidadeMedida() {
    const request = axios.get(`${consts.API_URL}/unidadeMedida/listarSelect`);
    return {
        type: 'FRETE_UNIDADE_MEDIDA_SELECT_LISTADO',
        payload: request
    };
}
	